'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _portal = require('./helpers/portal.js');

var _portal2 = _interopRequireDefault(_portal);

var _keyCodes = require('./helpers/key-codes');

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _uiBtn = require('@rnb/ui-btn');

var _uiBtn2 = _interopRequireDefault(_uiBtn);

var _ramjetClientOnly = require('./helpers/ramjet.client-only.js');

var _ramjetClientOnly2 = _interopRequireDefault(_ramjetClientOnly);

var _uiCarousel = require('@rnb/ui-carousel');

var _uiCarousel2 = _interopRequireDefault(_uiCarousel);

var _uiNavDots = require('@rnb/ui-nav-dots');

var _uiNavDots2 = _interopRequireDefault(_uiNavDots);

var _uiLightbox = require('./ui-lightbox.less');

var _uiLightbox2 = _interopRequireDefault(_uiLightbox);

var _style = require('./icons/style.less');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UiLightbox = function (_Component) {
    _inherits(UiLightbox, _Component);

    function UiLightbox(props) {
        _classCallCheck(this, UiLightbox);

        var _this = _possibleConstructorReturn(this, (UiLightbox.__proto__ || Object.getPrototypeOf(UiLightbox)).call(this, props));

        _this.isUnmounting = false;
        _this.isTransformToLightboxItemInitiated = false;
        _this.onClose = _this.onClose.bind(_this);
        _this.onShow = _this.onShow.bind(_this);
        _this.playYouTubeVideo = _this.playYouTubeVideo.bind(_this);
        _this.pageUpdate = _this.pageUpdate.bind(_this);
        _this.onNavigateNext = _this.onNavigateNext.bind(_this);
        _this.onNavigatePrevious = _this.onNavigatePrevious.bind(_this);

        _this.state = {
            isShowing: false,
            items: [],
            animateTo: "",
            isAnimating: false,
            carouselPage: 0,
            carouselLastPage: 0
        };

        _this.ref_animate_to = _react2.default.createRef();
        _this.ref_ui_carousel = _react2.default.createRef();
        _this.ref_inner_list_wrapper = _react2.default.createRef();
        _this.keyCodes = new _keyCodes2.default();
        return _this;
    }

    _createClass(UiLightbox, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeEventListenerHandleGlobalClick();
            this.removeEventListenerHandleGlobalKeyDown();
        }
    }, {
        key: 'addEventListenerHandleGlobalClick',
        value: function addEventListenerHandleGlobalClick() {
            this.eventListenerHandleGlobalClick = this.handleGlobalClick.bind(this);
            document.addEventListener('click', this.eventListenerHandleGlobalClick, false);
        }
    }, {
        key: 'addEventListenerHandleGlobalKeyDown',
        value: function addEventListenerHandleGlobalKeyDown() {
            this.eventListenerHandleGlobalKeydown = this.handleGlobalKeyDown.bind(this);
            document.addEventListener('keydown', this.eventListenerHandleGlobalKeydown, false);
        }
    }, {
        key: 'removeEventListenerHandleGlobalClick',
        value: function removeEventListenerHandleGlobalClick() {
            document.removeEventListener('click', this.eventListenerHandleGlobalClick, false);
        }
    }, {
        key: 'removeEventListenerHandleGlobalKeyDown',
        value: function removeEventListenerHandleGlobalKeyDown() {
            document.removeEventListener('keydown', this.eventListenerHandleGlobalKeydown, false);
        }
    }, {
        key: 'handleGlobalClick',
        value: function handleGlobalClick(e) {
            var listItems = this.ref_inner_list_wrapper.current.querySelectorAll(".ui-lightbox__list-item");

            if (this.isOnNavigationEvent || e && listItems && listItems[this.state.page - 1].contains(e.target)) {
                this.isOnNavigationEvent = false;
                return;
            }

            this.onClose();
        }
    }, {
        key: 'handleGlobalKeyDown',
        value: function handleGlobalKeyDown(e) {
            var key = e.keyCode || e.which;

            switch (key) {
                case this.keyCodes.keys.KEY_ESCAPE:
                    this.onClose();
                    break;
                case this.keyCodes.keys.KEY_RIGHT:
                    this.onNavigateNext();
                    break;
                case this.keyCodes.keys.KEY_LEFT:
                    this.onNavigatePrevious();
                    break;
                default:
                    return false;
            }
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.toggleHideAreaOnShow(false);

            this.pauseAllVideoFromPlaying();
            this.removeEventListenerHandleGlobalClick();
            this.removeEventListenerHandleGlobalKeyDown();
            this.setState({
                isShowing: false,
                isAnimating: false,
                isAnimatingDone: false,
                animateTo: ""
            });
        }
    }, {
        key: 'playYouTubeVideo',
        value: function playYouTubeVideo() {
            var _this2 = this;

            this.isOnNavigationEvent = true;
            var listItems = this.ref_inner_list_wrapper.current.querySelectorAll(".ui-lightbox__list-item");
            var currentIframe = listItems[this.state.carouselPage - 1].querySelector(".ui-lightbox__iframe-youtube");
            currentIframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');

            this.setState(function (state) {
                var items = state.items.map(function (item, i) {
                    if (i === _this2.state.carouselPage - 1) {
                        item.isVideoPlaying = true;
                    }
                    return item;
                });

                return { items: items };
            });
        }
    }, {
        key: 'pauseAllVideoFromPlaying',
        value: function pauseAllVideoFromPlaying() {
            var youtubeIframes = this.ref_inner_list_wrapper.current.querySelectorAll(".ui-lightbox__iframe-youtube");

            if (youtubeIframes) {
                youtubeIframes.forEach(function (iframe) {
                    return iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                });
            }
        }
    }, {
        key: 'onShow',
        value: function onShow(items) {
            var _this3 = this;

            var itemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var el = arguments[2];

            if (this.isTransformToLightboxItemInitiated) {
                return;
            }

            if (items instanceof Array && items.length - 1 >= itemIndex) {
                this.isTransformToLightboxItemInitiated = true;
                if (!items[itemIndex].isLoaded) {
                    var image = new Image();
                    image.onload = function () {
                        if (!_this3.isUnmounting) {
                            _this3.onShowSetState(items, itemIndex, el);
                        }
                    };
                    image.onerror = function () {
                        if (!_this3.isUnmounting) {
                            _this3.onShowSetState(items, itemIndex, el);
                        }
                    };
                    image.src = items[itemIndex].url;
                } else {
                    this.onShowSetState(items, itemIndex, el, items[itemIndex]);
                }
            }
        }
    }, {
        key: 'onShowSetState',
        value: function onShowSetState(items, itemIndex, el) {
            var _this4 = this;

            items[itemIndex].isLoaded = true;

            if (items[itemIndex].type === "youtube") {
                items[itemIndex].autoPlay = true;
            }

            this.setState({
                isShowing: true,
                page: itemIndex + 1,
                lastPage: items.length,
                items: items,
                animateTo: _react2.default.createElement('img', { src: items[itemIndex].url, alt: '' })
            }, function () {
                var rect = _this4.ref_animate_to.current.getBoundingClientRect();

                _this4.ref_animate_to.current.style.width = rect.width + "px";
                _this4.ref_animate_to.current.style.height = rect.height + "px";

                _this4.setState({
                    isAnimating: true,
                    isAnimatingDone: false
                });

                _ramjetClientOnly2.default.transform(el, _this4.ref_animate_to.current, {
                    done: function done() {
                        _this4.setState({
                            isAnimating: false,
                            isAnimatingDone: true
                        }, function () {
                            _this4.toggleHideAreaOnShow(true);

                            _this4.addEventListenerHandleGlobalClick();
                            _this4.addEventListenerHandleGlobalKeyDown();
                            _this4.isTransformToLightboxItemInitiated = false;
                            _this4.ref_ui_carousel.current.update(itemIndex + 1, true);
                        });
                    }
                });
            });
        }
    }, {
        key: 'isValidNavigateNext',
        value: function isValidNavigateNext() {
            return this.state.items instanceof Array && this.state.items.length > 1 && this.state.carouselPage < this.state.carouselLastPage;
        }
    }, {
        key: 'isValidNavigatePrev',
        value: function isValidNavigatePrev() {
            return this.state.items instanceof Array && this.state.items.length > 1 && this.state.carouselPage > 1;
        }
    }, {
        key: 'onNavigateNext',
        value: function onNavigateNext() {
            this.isOnNavigationEvent = true;
            if (this.state.carouselPage < this.state.carouselLastPage && this.isValidNavigateNext()) {
                this.pauseAllVideoFromPlaying();
                this.ref_ui_carousel.current.update(this.state.carouselPage + 1);
            }
        }
    }, {
        key: 'onNavigatePrevious',
        value: function onNavigatePrevious() {
            this.isOnNavigationEvent = true;
            if (this.state.carouselPage > 1 && this.isValidNavigatePrev()) {
                this.pauseAllVideoFromPlaying();
                this.ref_ui_carousel.current.update(this.state.carouselPage - 1);
            }
        }
    }, {
        key: 'renderItem',
        value: function renderItem(item) {
            var _this5 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'ui-lightbox__list-item ui-lightbox__list-item-' + item.type + '-outerwrapper' },
                    item.type === "image" && item.url && _react2.default.createElement('img', { className: 'ui-lightbox__image', src: item.url, alt: '' }),
                    item.type === "youtube" && item.youtubeUrl && _react2.default.createElement(
                        _react.Fragment,
                        null,
                        _react2.default.createElement('div', { className: ['icon-play_circle_filled', "ui-lightbox__icon-play", item.isVideoPlaying || item.autoPlay ? 'ui-lightbox__icon-play--display-none' : ''].join(" "), onClick: function onClick() {
                                return _this5.playYouTubeVideo(item);
                            } }),
                        _react2.default.createElement('img', { className: ['ui-lightbox__youtube-poster', item.isVideoPlaying || item.autoPlay ? 'ui-lightbox__youtube-poster--display-none' : ''].join(" "), src: item.url, alt: '', onClick: function onClick() {
                                return _this5.playYouTubeVideo(item);
                            } }),
                        _react2.default.createElement(
                            'div',
                            { className: ['ui-lightbox__list-item-' + item.type + '-innerwrapper', item.isVideoPlaying || item.autoPlay ? 'ui-lightbox__list-item-' + item.type + '-innerwrapper--playing' : ''].join(" ") },
                            _react2.default.createElement('iframe', { src: item.youtubeUrl + "?enablejsapi=1" + (item.autoPlay ? "&autoplay=1" : "") + (item.urlArgs ? item.urlArgs : ""), className: 'ui-lightbox__iframe-youtube', frameBorder: '0', allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowFullScreen: true })
                        )
                    ),
                    item.html && _react2.default.createElement(
                        _react.Fragment,
                        null,
                        item.html
                    )
                )
            );
        }
    }, {
        key: 'pageUpdate',
        value: function pageUpdate(page, lastPage) {
            this.setState({
                carouselPage: page,
                carouselLastPage: lastPage
            });
        }
    }, {
        key: 'toggleHideAreaOnShow',
        value: function toggleHideAreaOnShow(bool) {
            if (bool) {
                this.lastScrollTopPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

                if (this.props.refElementHideAreaOnShow && this.props.hideAreaOnShowClassName) {
                    this.props.refElementHideAreaOnShow.classList.add(this.props.hideAreaOnShowClassName);
                }
            } else {
                document.body.scrollTop = this.lastScrollTopPosition;
                document.body.parentNode.scrollTop = this.lastScrollTopPosition;

                if (this.props.refElementHideAreaOnShow && this.props.hideAreaOnShowClassName) {
                    this.props.refElementHideAreaOnShow.classList.remove(this.props.hideAreaOnShowClassName);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            if (this.state.isAnimatingDone) {
                this.ref_animate_to.current.style.height = "";
                this.ref_animate_to.current.style.width = "";
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _portal2.default,
                    { portalId: this.props.portalId },
                    _react2.default.createElement(
                        'div',
                        { ref: this.ref_animate_to,
                            className: ['ui-lightbox__animate-to', this.state.isAnimating ? 'ui-lightbox__animate-to--hidden' : '', this.state.isAnimatingDone === true ? 'ui-lightbox__animate-to--display-none' : ''].join(" ")
                        },
                        this.state.isAnimatingDone ? '' : this.state.animateTo
                    ),
                    _react2.default.createElement('div', { className: ['ui-lightbox__overlay', this.state.isAnimating || this.state.isAnimatingDone ? 'ui-lightbox__overlay--full-opacity' : 'ui-lightbox--hidden'].join(" ") }),
                    _react2.default.createElement(
                        'div',
                        { className: ['ui-lightbox', this.state.isAnimatingDone === true ? '' : 'ui-lightbox--visually-hidden'].join(" ") },
                        _react2.default.createElement(
                            'div',
                            { className: 'ui-lightbox__outer-wrapper' },
                            this.state.isShowing && _react2.default.createElement(_uiBtn2.default, { iconLeft: this.props.iconCloseBtn, className: "ui-lightbox__close-btn" }),
                            _react2.default.createElement(
                                'div',
                                { className: ['ui-lightbox__inner-wrapper', this.state.isShowing ? '' : 'ui-lightbox__list-wrapper--visually-hidden'].join(" ") },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'ui-lightbox__outer-list-wrapper' },
                                    _react2.default.createElement(
                                        'div',
                                        { ref: this.ref_inner_list_wrapper, className: 'ui-lightbox__inner-list-wrapper' },
                                        _react2.default.createElement(_uiCarousel2.default, { config: this.props.carouselConfig,
                                            ref: this.ref_ui_carousel,
                                            pageUpdate: this.pageUpdate,
                                            listItems: this.state.items.map(function (item) {
                                                return _this6.renderItem(item);
                                            }) }),
                                        this.state.isShowing && _react2.default.createElement(
                                            _react.Fragment,
                                            null,
                                            this.state.items.length > 1 && _react2.default.createElement(
                                                'div',
                                                { className: "ui-lightbox__navigate-wrapper" },
                                                _react2.default.createElement(_uiBtn2.default, { iconLeft: this.props.iconNavPrev,
                                                    className: ["ui-lightbox__navigate-prev", this.isValidNavigatePrev() ? '' : 'ui-lightbox__navigate-prev--disabled'].join(" "),
                                                    onClick: this.onNavigatePrevious }),
                                                _react2.default.createElement(_uiBtn2.default, { iconLeft: this.props.iconNavNext,
                                                    className: ["ui-lightbox__navigate-next", this.isValidNavigateNext() ? '' : 'ui-lightbox__navigate-next--disabled'].join(" "),
                                                    onClick: this.onNavigateNext })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: "ui-lightbox__ui-nav-dots-wrapper" },
                                                _react2.default.createElement(_uiNavDots2.default, { page: this.state.carouselPage, lastPage: this.state.carouselLastPage })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return UiLightbox;
}(_react.Component);

UiLightbox.defaultProps = {
    carouselConfig: [{
        start: 0,
        end: 9999,
        itemsPerPage: 1,
        listIndention: 0,
        listItemSpacing: 0
    }],
    iconCloseBtn: {
        "icon": "icon-close",
        "align": "center"
    },
    iconNavPrev: {
        "icon": "icon-keyboard_arrow_left",
        "align": "center"
    },
    iconNavNext: {
        "icon": "icon-keyboard_arrow_right",
        "align": "center"
    },
    refElementHideAreaOnShow: null,
    hideAreaOnShowClassName: null
};
exports.default = UiLightbox;